// extracted by mini-css-extract-plugin
module.exports = {"content":"_1IO9lvdtu6OOGAX39s1eh9","cardContainer":"_2BP12pFr3mCchhSpKYFiBU","title":"xFVoJ2s_KxyqkAXldFl2F"};